import * as THREE from 'three';

import Store from '../Store';



export default class EnvCubeOverlay {
  constructor(envCube, faceI) {

    this.envCube = envCube;
    this.faceI = faceI; // The index of the face you want to overlay
    this.overlayMaterial = null;

    this.createOverlayFace();
  }

  createOverlayFace() {
    const { scene } = Store.getState();
    const loader = new THREE.TextureLoader();
    const faceW = 60;
    const faceH = 32;
    const x = -1.3;
    const y = 2.5;
    const z = -97;

    loader.load(`https://static.mused.org/apophis_bg.jpg`, (bgTex) => {
      const bgPlane = new THREE.PlaneGeometry(faceW, faceH);

      bgTex.minFilter = THREE.LinearMipMapLinearFilter;
      bgTex.magFilter = THREE.LinearFilter;
      bgTex.anisotropy = 16;
      bgTex.colorSpace = THREE.SRGBColorSpace;
      bgTex.needsUpdate = true;

      this.bgMaterial = new THREE.MeshBasicMaterial({
        map: bgTex, 
        transparent: true,
        opacity: 1,
      });

      this.bg = new THREE.Mesh(bgPlane, this.bgMaterial);
      this.bg.rotation.set(0, 0, 0);
      this.bg.position.set(x, y, z);
      this.bg.renderOrder = 9;
      
      // might be able to take out the bg now that render order is sorted
      // if not, removing this will just show a black bg behind the png of the
      // highlights
      // scene.add(this.bg);


      loader.load(`https://static.mused.org/apophis7.png`, (overlayTex) => {
        overlayTex.minFilter = THREE.LinearMipMapLinearFilter;
        overlayTex.magFilter = THREE.LinearFilter;
        overlayTex.anisotropy = 16;
        overlayTex.colorSpace = THREE.SRGBColorSpace;
        overlayTex.needsUpdate = true;
        
        const overlayPlane = new THREE.PlaneGeometry(faceW, faceH);
        this.overlayMaterial = new THREE.MeshBasicMaterial({
          map: overlayTex, 
          transparent: true,
          opacity: 0,
          depthWrite: false, 
          depthTest: false,
        });

        this.overlay = new THREE.Mesh(overlayPlane, this.overlayMaterial);
        this.overlay.rotation.set(0, 0, 0);
        this.overlay.position.set(x, y, z+0.01);
        this.overlay.layers.enable(1);
        this.overlay.renderOrder = 10;

        scene.add(this.overlay);
        // this.toggleFade();
      });
    });

  }

  toggleFade() {
    const { app } = Store.getState();
    this.fadeIn(2000, () => {
      setTimeout(() => {
        this.fadeOut(2000, () => {
          setTimeout(() => {
            this.toggleFade();
          }, 500);
        });
      }, 500);
    });
  }

  fadeIn(duration = 600, callback) {
    const { app } = Store.getState();
    let progress = 0;
    const interval = setInterval(() => {
      progress += 20;
      const factor = progress / duration;
      this.overlayMaterial.opacity = 1 * factor;

      // const bgOpacity = 1 - (factor * 0.9);
      const bgOpacity = 1 - factor;

      // app.envCube.dimScene(bgOpacity);
      app.setLightIntensity(0.6);
      // this.bgMaterial.opacity = bgOpacity;
      this.bgMaterial.opacity = 0; 

      if (progress >= duration) {
        clearInterval(interval);
        if (callback) callback();
      }
    }, 20);
  }

  fadeOut(duration = 600, callback) {
    const { app } = Store.getState();
    let progress = 0;
    const interval = setInterval(() => {
      progress += 20;
      const factor = 1 - (progress / duration);
      this.overlayMaterial.opacity = factor;

      // const bgOpacity = 1 - (factor * 0.9);
      const bgOpacity = 1 - factor;

      app.setLightIntensity(1);
      // app.envCube.dimScene(bgOpacity);

      this.bgMaterial.opacity = 0; 

      if (progress >= duration) {
        clearInterval(interval);
        if (callback) callback();
      }
    }, 20);
  }
}
